// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-tabs-card > .ant-tabs-nav {
  margin-bottom: 0;
}
.ant-tabs-card > .ant-tabs-nav > .ant-tabs-nav-wrap > .ant-tabs-nav-list > .ant-tabs-tab > .ant-tabs-tab-btn {
  color: var(--text-secondary);
}
.ant-tabs-card > .ant-tabs-nav > .ant-tabs-nav-wrap > .ant-tabs-nav-list > .ant-tabs-tab > .ant-tabs-tab-btn:hover {
  color: var(--text-base);
}
.ant-tabs-card > .ant-tabs-nav > .ant-tabs-nav-wrap > .ant-tabs-nav-list > .ant-tabs-tab.ant-tabs-tab-active > .ant-tabs-tab-btn {
  color: var(--text-base);
}
.ant-tabs-card > .ant-tabs-content-holder {
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-top: none;
  background-color: white;
}
.ant-tabs-card > .ant-tabs-content-holder > .ant-tabs-content > .ant-tabs-tabpane > .ngw-gui-antd-tab-padding {
  padding: 1em;
}
.ant-tabs-parent-height {
  height: 100%;
}
.ant-tabs-parent-height > .ant-tabs-content-holder {
  position: relative;
}
.ant-tabs-parent-height > .ant-tabs-content-holder > .ant-tabs-content {
  position: absolute;
  inset: 0;
}
.ant-tabs-parent-height > .ant-tabs-content-holder > .ant-tabs-content > .ant-tabs-tabpane {
  position: absolute;
  inset: 0;
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/gui/nodepkg/antd/tabs/index.less"],"names":[],"mappings":"AAAA;EAEQ,gBAAA;AAAR;AAFA;EAMgB,4BAAA;AADhB;AAGgB;EACI,uBAAA;AADpB;AAKY;EAEQ,uBAAA;AAJpB;AAXA;EAsBQ,qCAAA;EACA,gBAAA;EACA,uBAAA;AARR;AAhBA;EA2BY,YAAA;AARZ;AAaA;EACI,YAAA;AAXJ;AAUA;EAIQ,kBAAA;AAXR;AAOA;EAOY,kBAAA;EACA,QAAA;AAXZ;AAGA;EAWgB,kBAAA;EACA,QAAA;EACA,gBAAA;AAXhB","sourcesContent":[".ant-tabs-card {\n    > .ant-tabs-nav {\n        margin-bottom: 0;\n\n        > .ant-tabs-nav-wrap > .ant-tabs-nav-list > .ant-tabs-tab {\n            > .ant-tabs-tab-btn {\n                color: var(--text-secondary);\n\n                &:hover {\n                    color: var(--text-base);\n                }\n            }\n\n            &.ant-tabs-tab-active {\n                > .ant-tabs-tab-btn {\n                    color: var(--text-base);\n                }\n            }\n        }\n    }\n\n    > .ant-tabs-content-holder {\n        border: 1px solid rgba(0, 0, 0, 0.06);\n        border-top: none;\n        background-color: white;\n\n        > .ant-tabs-content > .ant-tabs-tabpane > .ngw-gui-antd-tab-padding {\n            padding: 1em;\n        }\n    }\n}\n\n.ant-tabs-parent-height {\n    height: 100%;\n\n    > .ant-tabs-content-holder {\n        position: relative;\n\n        > .ant-tabs-content {\n            position: absolute;\n            inset: 0;\n\n            > .ant-tabs-tabpane {\n                position: absolute;\n                inset: 0;\n                overflow-y: auto;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
